import { all, call, takeLatest, put } from 'redux-saga/effects';
import { homeActions } from './homePageSlice';
import { axiosSSO } from 'config';
import { notificationHandler } from 'utils/utils';

export function* fetchUser({ payload: dataPayload }) {
    try {
        const response = yield axiosSSO.get(`/user/${dataPayload.userId}`);
        yield put(homeActions.fetchUserSuccess(response.data));
        yield put(homeActions.fetchRolesStart());
        yield put(homeActions.fetchAppsStart());
    } catch (err) {
        yield call(notificationHandler, {
            err,
            action: homeActions.fetchUserFailed,
            title: 'Error fetching users',
        });
    }
}

export function* onFetchUserStart() {
    yield takeLatest(homeActions.fetchUserStart.type, fetchUser);
}

export function* fetchRoles() {
    try {
        const response = yield axiosSSO.get(`/role/all`);
        yield put(homeActions.fetchRolesSuccess(response.data.args));
    } catch (err) {
        yield call(notificationHandler, {
            err,
            action: homeActions.fetchRolesFailed,
            title: 'Error fetching roles',
        });
    }
}

export function* onFetchRolesStart() {
    yield takeLatest(homeActions.fetchRolesStart.type, fetchRoles);
}

export function* fetchApps() {
    try {
        const response = yield axiosSSO.get(`/application/all`);
        yield put(homeActions.fetchAppsSuccess(response.data));
    } catch (err) {
        yield call(notificationHandler, {
            err,
            action: homeActions.fetchAppsFailed,
            title: 'Error fetching applications',
        });
    }
}

export function* onFetchAppsStart() {
    yield takeLatest(homeActions.fetchAppsStart.type, fetchApps);
}

export function* homeSaga() {
    yield all([call(onFetchUserStart), call(onFetchRolesStart), call(onFetchAppsStart)]); //
}
